<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Page Settings</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Changes</span><span v-if="saved">Changes Saved</span></button>
        </div>
      </div>

      <!-- <div class="pagePreviewGrid">
        <div> -->
          <!-- Home Page -->
          <cmsPagesHome v-if="state.pagesView === 'home'"></cmsPagesHome>
          <!-- About Page -->
          <cmsPagesAbout v-if="state.pagesView === 'about'"></cmsPagesAbout>
          <!-- Services Page -->
          <cmsPagesServices v-if="state.pagesView === 'services'"></cmsPagesServices>
          <!-- News Page -->
          <cmsPagesNews v-if="state.pagesView === 'news'"></cmsPagesNews>
          <!-- Shop Page -->
          <cmsPagesShop v-if="state.pagesView === 'shop'"></cmsPagesShop>
          <!-- Portfolio Page -->
          <cmsPagesPortfolio v-if="state.pagesView === 'portfolio'"></cmsPagesPortfolio>
          <!-- Repairs Page -->
          <cmsPagesRepairs v-if="state.pagesView === 'repairs'"></cmsPagesRepairs>
          <!-- Team Page(s) -->
          <cmsPagesTeam v-if="state.pagesView === 'team'"></cmsPagesTeam>
          <!-- Contact Page -->
          <cmsPagesContact v-if="state.pagesView === 'contact'"></cmsPagesContact>
          <!-- Sitemap Page -->
          <div v-if="state.pagesView === 'sitemap'">
            <div class="inputCard">
              <header>Sitemap Page Content</header>
              <div class="content">
                <div class="input-row w3-padding-8">
                  <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="state.siteData.pages.sitemap.content"></tinymce-editor>
                </div>
              </div>
            </div>
          </div>
        <!-- </div>
        <div>
          <embed :src="'http://levelsevenstudio.com/frontend?domain=' + state.activeSite.domain" class="previewContainer" />
        </div>
      </div> -->
      <div class="w3-right-align w3-margin-top w3-margin-bottom">
        <button class='w3-button' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Changes</span><span v-if="saved">Changes Saved</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import cmsPagesHome from './pages/home/cmsPagesHome'
import cmsPagesAbout from './pages/about/cmsPagesAbout'
import cmsPagesServices from './pages/services/cmsPagesServices'
import cmsPagesNews from './pages/news/cmsPagesNews'
import cmsPagesShop from './pages/shop/cmsPagesShop'
import cmsPagesPortfolio from './pages/portfolio/cmsPagesPortfolio'
import cmsPagesRepairs from './pages/repairs/cmsPagesRepairs'
import cmsPagesTeam from './pages/team/cmsPagesTeam'
import cmsPagesContact from './pages/contact/cmsPagesContact'
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsSettings',
  data() {
    return {
      state: dataStore.state,
      view: 'home',
      saving: false,
      saved: false,
      menuOpen: false
    }
  },
  components: {
    'tinymce-editor': Editor,
    'cmsPagesHome': cmsPagesHome,
    'cmsPagesAbout': cmsPagesAbout,
    'cmsPagesServices': cmsPagesServices,
    'cmsPagesNews': cmsPagesNews,
    'cmsPagesShop': cmsPagesShop,
    'cmsPagesPortfolio': cmsPagesPortfolio,
    'cmsPagesRepairs': cmsPagesRepairs,
    'cmsPagesTeam': cmsPagesTeam,
    'cmsPagesContact': cmsPagesContact
  },
  created() {
    if (this.state.pageNav !== '') {
      this.view = this.state.pageNav
      this.state.pageNav = 'home'
    }
  },
  methods: {
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    }
  }
}
</script>

<style scoped>
  .faqsContentGrid {display:grid; grid-template-columns: 250px 1fr 130px; grid-gap: 8px; border-bottom:1px solid #ccc;}
  .faqsContentGrid:last-child {border-bottom:0;}

  .pagesMenuNav .w3-bar-item:last-child {border-radius: 0 0 5px 5px;}

  .pagePreviewGrid {display:grid; grid-template-rows: 1fr; grid-template-columns: 350px 1fr; grid-gap: 8px;}
  .previewContainer {height: calc(100vh - 98px); width:100%;}
  /* embed {width: 130% !important;
    height: 100% !important;
    -webkit-transform: scale(0.75);
    transform: scale(0.75);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;} */
  
  @media (max-width: 600px) {
    .pagesMenuNav {margin:8px 0;}
  }
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsPages.vue